/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-14 14:59:51
 * @Description: 不可进行二次销售
 */
// main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import * as directives from '@/utils/directive'
import * as filters from '@/utils/filters'  // 导入 filters
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/main.css'

Vue.use(ElementUI)

// 注册全局指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')